<script setup lang="ts">
import ConnxIcon from '@/components/Atoms/ConnxIcon.vue';
</script>

<template>
  <div class="tw-w-full tw-h-full tw-p-4 tw-flex tw-items-center tw-justify-center">
    <div
      class="tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-text-connx-grey-tint-30"
    >
      <connx-icon
        name="fal fa-digital-tachograph"
        class="tw-h-12 tw-w-12 tw-mb-2"
      ></connx-icon>
      <div class="tw-text-lg tw-font-medium">No data available</div>
      <div class="tw-text-sm tw-mt-1">Try adjusting filters</div>
    </div>
  </div>
</template>
